const files = require.context('./layouts/', false, /\.vue$/)
const templateLayouts = {}

files.keys().forEach(key => {
    if (key === './index.js') return;
    templateLayouts[key.replace(/(\.\/|\.vue)/g, '')] = files(key)
})

export { templateLayouts }
